/**
 * Created by mac on 4/8/18
 */

const VKAds = function (pluginName) {
    AdsPlugin.call(this, pluginName || connector.VK, {
        sdk: SdkManager.SDK_VK
    });
};

VKAds.prototype = Object.create(AdsPlugin.prototype);
VKAds.prototype.constructor = VKAds;

VKAds.isAppropriate = function () {
    return connector.platform.oneOf(connector.VK);
};

VKAds.prototype.isNoAdsProductAvailable = function () {
    return true;
};

VKAds.prototype.isStickySupported = function () {
    return true;
};

VKAds.prototype._cacheAd = function (name, callback) {
    vkBridge.send("VKWebAppCheckNativeAds", {
        "ad_format": name === AdsPlugin.REWARDED ? "reward" : "interstitial"
    }).then((data) => {
        if (data.result) {
            console.log("VKWebAppCheckNativeAds: have ads!", name);
            callback(connector.CODE_SUCCEED, true);
        } else {
            console.log("VKWebAppCheckNativeAds: no ads!", name, data);
            callback(AdsPlugin.ERROR_LOADING_FAILED);
        }
    }).catch((error) => {
        console.log("VKWebAppCheckNativeAds: error", name, error);
        callback(AdsPlugin.ERROR_LOADING_UNKNOWN);
    });
};

VKAds.prototype._playAd = function (name, ad, callback) {
    vkBridge.send("VKWebAppShowNativeAds", {
        ad_format: name === AdsPlugin.REWARDED ? "reward" : "interstitial"
    }).then((data) => {
        if (data.result) {
            console.log("VKWebAppShowNativeAds: shown", name);
            callback(connector.CODE_SUCCEED);
        } else {
            console.log("VKWebAppShowNativeAds: canceled", name, data);
            if (name === AdsPlugin.REWARDED) {
                callback(ERRORS.SHOW_REWARDED.UNKNOWN, data);
            } else {
                callback(ERRORS.SHOW_INTERSTITIAL.UNKNOWN, data);
            }
        }
    }).catch((error) => {
        console.log("VKWebAppShowNativeAds: error", name, error);
        if (name === AdsPlugin.REWARDED) {
            callback(ERRORS.SHOW_REWARDED.UNKNOWN, error && error.error_data || error);
        } else {
            callback(ERRORS.SHOW_INTERSTITIAL.UNKNOWN, error && error.error_data || error);
        }
    });
};

VKAds.prototype.onSdkEvent = function (type, data) {
    if (type === "VKWebAppBannerAdUpdated" && data.result === true) {
        this.bus.trigger("sticky:render");
        this.onImpressionEvent(AdsPlugin.STICKY);
    }
};

VKAds.prototype.showSticky = function (callback) {
    vkBridge.send("VKWebAppShowBannerAd", {
        layout_type: "resize",
        can_close: false
    })
        .then((data) => {
            if (!data || !data.result) {
                callback(ERRORS.SHOW_STICKY.UNKNOWN);
                return;
            }
            callback(connector.CODE_SUCCEED, {
                width: 0,
                height: 0
            });
            this.bus.trigger("sticky:render");
            this.onImpressionEvent(AdsPlugin.STICKY);
        })
        .catch(() => {
            callback(ERRORS.SHOW_STICKY.UNKNOWN);
        });
};

VKAds.prototype.closeSticky = function (callback) {
    vkBridge.send("VKWebAppHideBannerAd")
        .then((data) => {
            if (!data || !data.result) {
                callback(ERRORS.CLOSE_STICKY.UNKNOWN);
                return; 
            }

            callback(connector.CODE_SUCCEED);
        })
        .catch(() => {
            callback(ERRORS.CLOSE_STICKY.UNKNOWN);
        });
};